import { DashboardLayout } from "./DashboardLayout";
import { MarketingLayout } from "./MarketingLayout";
import { usePlatformStore } from "../store";

export type Props = {
  title: string;
};

export function SupportLayout({ title }: Props) {
  const user = usePlatformStore((s) => s.user);

  const isUserLoggedIn = !!user;

  return isUserLoggedIn ? (
    <DashboardLayout title={title} />
  ) : (
    <MarketingLayout title={title} />
  );
}

export default SupportLayout;
